"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainerLoadingSplash = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const components_1 = require("./components");
function TrainerLoadingSplash({ progressBar, state, style, ...props }) {
    var _a, _b, _c, _d;
    if ((state === null || state === void 0 ? void 0 : state.status) === "ready")
        return null;
    const text = (state === null || state === void 0 ? void 0 : state.status) === "error"
        ? `Loading failed: ${(_b = (_a = state.error) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : "Unknown error"}`
        : `Loading: ${Math.floor(((_c = state === null || state === void 0 ? void 0 : state.assetProgress) !== null && _c !== void 0 ? _c : 0) * 100)}%`;
    return ((0, jsx_runtime_1.jsxs)("div", { id: "trainer-loading", ...props, style: {
            fontSize: "16pt",
            position: "absolute",
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            ...style,
        }, children: [(0, jsx_runtime_1.jsx)("div", { children: text }), (state === null || state === void 0 ? void 0 : state.status) !== "error" && ((0, jsx_runtime_1.jsx)(components_1.ProgressBar, { backgroundColor: "#282828", borderColor: "#FFFF00", fillColor: "#FFFF00", progress: (_d = state === null || state === void 0 ? void 0 : state.assetProgress) !== null && _d !== void 0 ? _d : 0, ...progressBar, style: { marginTop: "0.25rem", width: '50%', ...progressBar === null || progressBar === void 0 ? void 0 : progressBar.style } }))] }));
}
exports.TrainerLoadingSplash = TrainerLoadingSplash;
